import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, FileText, Mail, Settings, Wallet, Layers, Boxes, Image, HelpCircle, LogOut, KeyRound, ExternalLink } from "lucide-react";
import { useAdminAuth } from "./AdminAuth";
import { usePublicData } from "@/hooks/usePublicData";
import { resolveSite } from "@/lib/siteConfig";
import SiteLogo from "@/components/SiteLogo";

const nav = [
  { to: "/dekosta-yonetim", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "admin-nav-dashboard" },
  { to: "/dekosta-yonetim/teklifler", label: "Teklifler", icon: FileText, testid: "admin-nav-quotes" },
  { to: "/dekosta-yonetim/mesajlar", label: "Mesajlar", icon: Mail, testid: "admin-nav-messages" },
  { to: "/dekosta-yonetim/ayarlar", label: "Site Ayarları", icon: Settings, testid: "admin-nav-settings" },
  { to: "/dekosta-yonetim/fiyatlandirma", label: "Fiyatlandırma", icon: Wallet, testid: "admin-nav-pricing" },
  { to: "/dekosta-yonetim/hizmetler", label: "Hizmetler", icon: Layers, testid: "admin-nav-services" },
  { to: "/dekosta-yonetim/malzemeler", label: "Malzemeler", icon: Boxes, testid: "admin-nav-materials" },
  { to: "/dekosta-yonetim/portfoy", label: "Portföy", icon: Image, testid: "admin-nav-portfolio" },
  { to: "/dekosta-yonetim/faq", label: "SSS", icon: HelpCircle, testid: "admin-nav-faq" },
  { to: "/dekosta-yonetim/sifre", label: "Şifre Değiştir", icon: KeyRound, testid: "admin-nav-password" },
];

export default function AdminLayout() {
  const { user, logout } = useAdminAuth();
  const { settings } = usePublicData();
  const site = resolveSite(settings);
  const nav_ = useNavigate();
  const handleLogout = () => { logout(); nav_("/dekosta-yonetim/login"); };

  return (
    <div className="min-h-screen bg-site text-zinc-100 flex">
      {/* Sidebar */}
      <aside className="w-64 border-r border-white/10 bg-surface-1 flex flex-col sticky top-0 h-screen">
        <div className="px-6 py-6 border-b border-white/10">
          <div>
            <SiteLogo site={site} size="sm" textClassName="text-sm" />
            <div className="font-mono text-[9px] uppercase tracking-[0.25em] text-zinc-500 mt-2">Yönetim</div>
          </div>
        </div>
        <nav className="flex-1 overflow-y-auto py-4">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={n.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-6 py-2.5 font-mono text-[11px] uppercase tracking-[0.18em] border-l-2 transition-colors ${
                  isActive ? "text-[#FF4F00] border-[#FF4F00] bg-[#FF4F00]/5" : "text-zinc-400 border-transparent hover:text-white hover:bg-white/5"
                }`
              }
            >
              <n.icon className="w-4 h-4" strokeWidth={1.5} />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-white/10 p-4 space-y-2">
          <a
            href="/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 hover:text-white transition-colors px-2 py-1"
          >
            <ExternalLink className="w-3.5 h-3.5" /> Siteyi Görüntüle
          </a>
          <div className="px-2">
            <div className="font-mono text-[9px] uppercase tracking-[0.25em] text-zinc-600">Giriş</div>
            <div className="text-xs text-zinc-300 truncate">{user?.email}</div>
          </div>
          <button
            onClick={handleLogout}
            data-testid="admin-logout-button"
            className="flex items-center gap-2 w-full px-2 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-400 hover:text-red-400 transition-colors"
          >
            <LogOut className="w-3.5 h-3.5" /> Çıkış
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 min-w-0">
        <div className="max-w-[1400px] px-6 md:px-10 py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
